import { useTheme } from 'styled-components';
import { VerifiedBadgeFilledIc, VerifiedBadgeOutlineIc } from '@dsch/dd-icons';
import * as Styled from 'components/PageWrappers/AdDetails/components/VerificationModal/VerificationModal.styled';
import { VerificationModalProps } from 'components/PageWrappers/AdDetails/components/VerificationModal/VerificationModal.typed';
import { BaseModal } from 'components/Toolkit/Modal/BaseModal';

const VerificationModal = ({ isOpen, askToClose }: VerificationModalProps) => {
  const theme = useTheme();

  const verificationItems = [
    {
      text: (
        <>
          <strong>Full verification:</strong> Email, Phone and Payment card
          verified
        </>
      ),
      icon: (
        <VerifiedBadgeFilledIc
          color={theme.colors.GREEN_DARK}
          width={16}
          height={16}
        />
      ),
      id: 'fully-verified',
    },
    {
      text: (
        <>
          <strong>Partial verification:</strong> Email and Phone verified
        </>
      ),
      icon: (
        <VerifiedBadgeOutlineIc
          color={theme.colors.GREEN_DARK}
          width={16}
          height={16}
        />
      ),
      id: 'partial-verified',
    },
    {
      text: (
        <>
          <strong>Basic verification:</strong> Email or Phone verified
        </>
      ),
      icon: (
        <VerifiedBadgeOutlineIc
          color={theme.colors.GREY}
          width={16}
          height={16}
        />
      ),
      id: 'basic-verified',
    },
  ];

  return (
    <BaseModal isOpen={isOpen} askToClose={askToClose} showCloseIcon={true}>
      <Styled.ModalTitle>Verification status</Styled.ModalTitle>
      <Styled.Items>
        {verificationItems.map((item) => (
          <Styled.Item key={item.id} data-testid={item.id}>
            <Styled.IconWrapper>{item.icon}</Styled.IconWrapper>
            <p>{item.text}</p>
          </Styled.Item>
        ))}
      </Styled.Items>
      <Styled.Separator />
      <Styled.BottomText data-testid={`verification-none`}>
        <strong>No verification badge:</strong> Neither Email nor Phone has been
        verified.
      </Styled.BottomText>
    </BaseModal>
  );
};

export { VerificationModal };
